import Type from './Type';
export function isIHeading(node) {
    return node.type === Type.Heading;
}
export default isIHeading;    //# sourceMappingURL=isIHeading.js.map
